module.exports = __webpack_public_path__ + "img/ModuleServices.e217eab1.png";